<template>
  <transition
    appear
    v-on:leave="leave"
    v-on:enter="enter"
    v-bind:css="false" >
    <section class="Preview" v-show="isOpen">
      <div class="Preview-overlay" @click="toggle"></div>
      <div class="Preview-wrapper" ref="wrapper">
        <div class="Preview-content" ref="content">
          <div @click="toggle">
            <CloseButton dark ref="closebtn"/>
          </div>
          <h2>{{ title }}</h2>
          <img :src="preview" alt="preview"/>
        </div>

        <!-- <slot></slot> -->
      </div>
    </section>
  </transition>
</template>

<script>
import CloseButton from '@/components/CloseButton'
// import ActionButton from '@/components/ActionButton2'
import { mapState } from 'vuex'
import gsap from 'gsap'

// const CloseButton = () => import('@/components/CloseButton.vue')

export default {
  components: {
    CloseButton
  },
  data () {
    return {
      isOpen: false
    }
  },
  computed: {
    ...mapState({
      title: state => state.textes.previewTitle,
      preview: 'screenshot'
    })
  },
  beforeDestroy () {
    this.toggle(false)
    if (this.tl) this.tl.kill()
  },
  methods: {
    toggle (force) {
      this.isOpen = !this.isOpen
      this.$emit('toggle', this.isOpen)
    },
    enter (e, done) {
      this.tl = gsap.timeline({
        onComplete: () => {
          done()
        }
      })
      this.tl.set(this.$el, { alpha: 1 }, 0)
      this.tl.to(this.$refs.overlay, { duration: 0.6, alpha: 1 }, 0)
      this.tl.fromTo(this.$refs.wrapper, { duration: 0.6, scaleY: 0, transformOrigin: 'bottom center', ease: 'expo.out' }, { scaleY: 1, scaleX: 1 }, 0)
      // this.tl.from(this.$refs.wrapper, { duration: 0.6, width: '45%', transformOrigin: 'right center', ease: 'expo.out' })
      this.tl.fromTo([this.$refs.content, this.$refs.closebtn.$el], { alpha: 0 }, { duration: 0.4, alpha: 1, stagger: 0.4 })
    },
    leave (e, done) {
      this.tl.kill()
      this.tl = gsap.timeline({
        onComplete: () => {
          done()
        }
      })
      this.tl.fromTo(this.$el, { duration: 0.6, alpha: 1 }, { alpha: 0 }, 0)
    }
  }
}
</script>

<style lang="stylus">

.Preview
  width 100%
  height 100%
  position absolute
  left 0
  right 0
  margin auto
  bottom 0
  .ActionButton
    position relative

  &-overlay
    position absolute
    background rgba(0, 0, 0, 0.5)
    width 100%
    height 100%
    top 0
    left 0
    right 0
    bottom 0
  &-wrapper
    background white
    position relative
    padding 90px
    padding-top 34px
    width 60%
    max-width 800px
    height auto
    position absolute
    left 0
    right 0
    margin auto
    bottom 0
    .CloseButton
      position absolute
      top 30px
      left 30px
    h2
      text-transform uppercase
      color black
      font-family 'LeagueMonoBold'
    img
      margin-top 3vw
      display inline-block
      max-width 100%
      max-height 500px
      padding-bottom 0
      border-radius 4px
      border 1px solid black
    .Share
      display flex
      justify-content center
      a
        display block
        align-self center

@media (max-width: 670px)
  .Preview
    width 100%
    h2
      font-size 0.8rem
      margin-bottom 15px
      padding 0 10px
    &-wrapper
      width calc(100% - 30px)
      padding-top 15px
      padding-left 45px
      padding-right 45px
      img
        max-height 250px
    .CloseButton
      top 10px
      left 10px

</style>
